"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetProductList = void 0;
const Base_1 = require("./Base");
exports.GetProductList = {
    url: Base_1.URL_BASE + "/GetProductList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetProductList.js.map